import { render, staticRenderFns } from "./MaterialInput.vue?vue&type=template&id=6a7e9454&scoped=true&"
import script from "./MaterialInput.vue?vue&type=script&lang=js&"
export * from "./MaterialInput.vue?vue&type=script&lang=js&"
import style0 from "./MaterialInput.vue?vue&type=style&index=0&id=6a7e9454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e9454",
  null
  
)

export default component.exports